import React, {useRef, useState} from 'react';
import { COLORS, ICONS } from '../general-components/icon';
import classNames from 'classnames';
import HoverIcon from './hover-icon';

interface Props {
	addSpacingOnHoverLeft:boolean;
	addSpacingOnHoverRight: boolean;
	isShowboardExpanded: boolean;
	onClick: Function;
	shotId: number;
};

export default function BetweenShot(props: Props) {
	const {
		addSpacingOnHoverLeft,
		addSpacingOnHoverRight,
		isShowboardExpanded,
		onClick,
		shotId,
	} = props;

	const [mouseIsOver, setMouseIsOver] = useState(false);
	const timmy = useRef<NodeJS.Timeout | null>(null);

	return (
		<div
			key={`between-shot-id-${shotId}`}
			className={classNames(
				isShowboardExpanded
					? 'between-shot'
					: 'between-shot-short',
				{
					'between-shot-hover': isShowboardExpanded && mouseIsOver,
					'between-shot-short-hover': !isShowboardExpanded && mouseIsOver,
					'between-shot-extra-space-on-hover-left': mouseIsOver && addSpacingOnHoverLeft,
					'between-shot-extra-space-on-hover-right': mouseIsOver && addSpacingOnHoverRight,
				},
			)}
			onMouseEnter={() => {
				if (timmy.current) {
					clearTimeout(timmy.current);
					timmy.current = null;
				}
				setMouseIsOver(true);
			}}
			onMouseLeave={() => {
				if (timmy.current) {
					clearTimeout(timmy.current);
					timmy.current = null;
				}
				timmy.current = setTimeout(() => {
					setMouseIsOver(false);
					// @ts-ignore
					clearTimeout(timmy.current);
					timmy.current = null;
				}, addSpacingOnHoverLeft ? 500 : 100);
			}}
		>
			<div className="between-shot-icon">
				<HoverIcon
					backgroundColor="#4F4C57"
					color={COLORS.LIGHT_GRAY}
					icon={ICONS.ADD}
					isShownOverride={mouseIsOver}
					onClick={(e: React.MouseEvent<HTMLButtonElement>) => onClick(e)}
					size={16}
					left={ isShowboardExpanded ? 24 : 7}
					top={isShowboardExpanded ? 46 : 12}
				>
					<div>&nbsp;</div>
				</HoverIcon>
			</div>
		</div>
	);
}
